import { supabase } from '@/integrations/supabase/client';

export interface QuoteCarouselCartItem {
  productId?: string;
  productName?: string;
  itemName?: string;
  totalPrice?: number;
  price?: number;
  imageUrl?: string;
}

/**
 * Link individual do item: a URL da proposta + `?item=<productId>`.
 * A loja abre destacando/rolando até o card desse item. Sem productId,
 * o card usa o link geral da proposta (fallback no builder do carrossel).
 */
export function buildItemProposalUrl(proposalUrl: string, productId?: string | null): string | null {
  const id = (productId || '').trim();
  if (!id) return null;
  const sep = proposalUrl.includes('?') ? '&' : '?';
  return `${proposalUrl}${sep}item=${encodeURIComponent(id)}`;
}

export interface SendQuoteCarouselResult {
  success: boolean;
  code?: string;
  error?: string;
}

/**
 * Envia a Proposta Digital como carrossel pelo WhatsApp do fornecedor (Evolution).
 * Nunca lança: em falha retorna success=false para a tela informar a falha, sem redirecionar.
 */
export async function sendQuoteCarousel(params: {
  supplierId: string;
  phone: string;
  message: string;
  proposalUrl: string;
  items: QuoteCarouselCartItem[];
}): Promise<SendQuoteCarouselResult> {
  try {
    const { data, error } = await supabase.functions.invoke('send-quote-carousel', {
      body: {
        supplierId: params.supplierId,
        phone: params.phone,
        message: params.message,
        proposalUrl: params.proposalUrl,
        items: params.items.map((item) => ({
          name: item.productName || item.itemName || '',
          price: Number(item.totalPrice ?? item.price ?? 0),
          imageUrl: item.imageUrl || null,
          url: buildItemProposalUrl(params.proposalUrl, item.productId),
        })),
      },
    });
    if (error) return { success: false, error: error.message };
    return { success: !!data?.success, code: data?.code, error: data?.success ? undefined : String(data?.error ?? '') };
  } catch (err) {
    return { success: false, error: err instanceof Error ? err.message : 'unknown' };
  }
}

export { buildQuoteCarouselMessage, QUOTE_CAROUSEL_INTRO_TEMPLATE } from '../../supabase/functions/_shared/quote-carousel';
